import { render, staticRenderFns } from "./IdentificationClient.vue?vue&type=template&id=c9c5097a&scoped=true"
import script from "./IdentificationClient.vue?vue&type=script&lang=js"
export * from "./IdentificationClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c5097a",
  null
  
)

export default component.exports